import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { TiptapDisplay } from "@msuite/ui/libs/tiptap";
import { useTranslation } from "@msuite/ui/localization";
import { guardArray } from "@msuite/utils/array";
import type { ProtocolFormContentSectionSchema } from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import { useMentionOptions } from "@/hooks/use-mention-options";
import { useProtocol } from "@/hooks/use-protocol";
import type { ProtocolPanelBaseProps } from "../shared";

export function ProtocolContent({ protocolId }: ProtocolPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();
	const mentionOptions = useMentionOptions();

	/** Query */
	const { protocol } = useProtocol(protocolId);

	/** Computed */
	const sections = guardArray(
		protocol?.content as ProtocolFormContentSectionSchema[] | null | undefined,
	);

	/** Render */
	return (
		<ContentCard
			icon={icon("Text")}
			title={t("protocols.content")}
		>
			{!sections.length ? (
				<p>{t("general.no_data_available")}</p>
			) : (
				<div className="v-stack gap-4">
					{sections.map((section) => (
						<div
							className="v-stack"
							key={section.id}
						>
							{section.title && <p className="heading">{section.title}</p>}
							{section.content ? (
								<TiptapDisplay
									json={section.content}
									{...mentionOptions}
								/>
							) : (
								<p>{guardString(null)}</p>
							)}
						</div>
					))}
				</div>
			)}
		</ContentCard>
	);
}
